import React, {Component} from 'react';
import { Chart } from 'react-google-charts'
import firebase from 'firebase/app'


export default class GraphController extends Component {

 

  constructor(props){
    super(props);
    this.state = {
      coordinatesData: [],
      errorData: null,
    }
  }



    componentDidMount() {
      let coordinates = []
      let error = null
      
      let userKey = this.props.user.email.replace(/[^a-zA-Z0-9]/g, "");
      let billsRef = firebase.database().ref('userBills/' + userKey + '/gas');
      this.setState({billsRef: billsRef});
      billsRef.on('value', getData)

      function getData(data) {
        if (data.exists()) {
          var db = data.val();
          var keys = Object.keys(db);
          for (var i = 0; i < keys.length; i++) {
            var k = keys[i];
            var usage = parseInt(db[k].usage)
            var month = (db[k].month.substring(db[k].month, db[k].month.length - 5));
            var year = (db[k].month.substring(3, db[k].month.length));
            var dateElem = new Date(year, month - 1)
            coordinates.push([dateElem, usage]);
          }
       } else {
        coordinates.push([dateElem, usage]);
        error = <p className="graph-error">You have no available gas data. Please input your bills to visualize the data.</p>
     }
        
      }

      coordinates = coordinates.sort(function(a, b){return a - b})

      this.setState({coordinatesData: coordinates, errorData: error})
  
    }

    componentWillUnmount() {
      this.state.billsRef.off();
    }



  render() {



    const rows = this.state.coordinatesData;
    
    const dateTicks = [
      new Date("2021", "0"),
      new Date()
    ];
    const options = {
      hAxis: {
        format: "MMM yyyy",
        ticks: dateTicks
      },
      vAxis: {
        title: 'Consumption in thms',
      },
      title: 'Gas Usage over Time',
    };

    return (

      

      <div className="line-chart">
        {this.state.errorData}
        <Chart
          chartType="LineChart"
          height="400px"
          columns={[
            { type: "date", label: "Month" },
            { type: "number", label: "Usage" },
          ]}
          rows={rows}
          options={options}
        />
      </div>
      

    );
  }

}